import React from 'react'
import {Route, IndexRedirect, IndexRoute} from 'react-router'
import {channels} from 'redux/modules/channels/utils'

import ChannelIntegrationView from 'views/ChannelIntegrationView'
import SettingsViewMenu from 'views/SettingsView/menu'
import SettingsCategoriesView from 'views/SettingsCategoriesView'
import SettingsChannelsView from 'views/SettingsChannelsView'
import SettingsCustomMappingView from 'views/SettingsCustomMappingView'
import IntegrationsView from 'views/IntegrationsView'
import SettingsReferrerMappingView from '../views/SettingsReferrerMappingView'
import SettingsUtmMappingView from '../views/SettingsUtmMappingView'
import SettingsDomainView from '../views/SettingsDomainView'
import SettingsRegionView from '../views/SettingsRegionView'
import OnboardingWizard from 'components/OnboardingWizard'
import {StepTypes} from 'redux/modules/onboard/steps'

const withOnboardingWizard = (Component, currentStep) => {
  return props => (
    <>
      <OnboardingWizard currentStep={currentStep} />
      <Component {...props} />
    </>
  )
}

export default trackRoute => {
  return (
    <Route path='settings' title='Settings'>
      <Route path='categories'>
        <IndexRedirect to='/settings/categories/Registration%20started' />
        <Route
          path=':categoryId'
          components={{menu: SettingsViewMenu, main: SettingsCategoriesView}}
          onEnter={trackRoute('settings_site-structure')}
        />
      </Route>
      <Route path='utm-mapping'>
        <IndexRedirect to='/settings/utm-mapping/unmapped' />
        <Route
          path=':type'
          components={{
            menu: SettingsViewMenu,
            main: withOnboardingWizard(
              SettingsUtmMappingView,
              StepTypes.UTM_MAPPING
            )
          }}
          onEnter={trackRoute('settings_utm-mapping')}
        />
      </Route>
      <Route path='custom-mapping'>
        <IndexRedirect to='/settings/custom-mapping/unmapped' />
        <Route
          path=':type'
          components={{
            menu: SettingsViewMenu,
            main: withOnboardingWizard(
              SettingsCustomMappingView,
              StepTypes.CUSTOM_MAPPING
            )
          }}
          onEnter={trackRoute('settings_custom-mapping')}
        />
      </Route>
      <Route path='referrer-mapping'>
        <IndexRedirect to='/settings/referrer-mapping/unmapped' />
        <Route
          path=':type'
          components={{
            menu: SettingsViewMenu,
            main: withOnboardingWizard(
              SettingsReferrerMappingView,
              StepTypes.REFERRER_MAPPING
            )
          }}
          onEnter={trackRoute('settings_referrer-mapping')}
        />
      </Route>
      <Route
        path='domains'
        components={{
          menu: SettingsViewMenu,
          main: withOnboardingWizard(
            SettingsDomainView,
            StepTypes.INTERNAL_WHITELISTING
          )
        }}
        onEnter={trackRoute('settings_domains')}
      />
      <Route
        path='countries'
        components={{
          menu: SettingsViewMenu,
          main: withOnboardingWizard(
            SettingsRegionView,
            StepTypes.COUNTRY_FILTER
          )
        }}
        onEnter={trackRoute('settings_countries')}
      />
      <Route path='channels'>
        <IndexRedirect to='/settings/channels/organic' />
        <Route
          path=':channelGroupId'
          components={{
            menu: SettingsViewMenu,
            main: withOnboardingWizard(
              SettingsChannelsView,
              StepTypes.CHANNEL_MAPPING
            )
          }}
          onEnter={trackRoute('settings_channels')}
        >
          <Route
            path=':channelId'
            components={{
              menu: SettingsViewMenu,
              main: withOnboardingWizard(
                SettingsChannelsView,
                StepTypes.CHANNEL_MAPPING
              )
            }}
          >
            <Route
              path=':integrationId'
              components={{
                menu: SettingsViewMenu,
                main: withOnboardingWizard(
                  SettingsChannelsView,
                  StepTypes.CHANNEL_MAPPING
                )
              }}
            />
          </Route>
        </Route>
      </Route>
      <Route path='integrations' title='Integrations'>
        <Route path=':channelGroupId'>
          <Route path=':channelId'>
            <IndexRoute
              component={ChannelIntegrationView}
              title={({channelGroupId, channelId}) => {
                const channelLabel =
                  channels[`${channelGroupId}/${channelId}`].label
                return `${channelLabel} Integration Details`
              }}
              withBreadcrumbs
            />
          </Route>
        </Route>
        <IndexRoute
          components={{
            menu: SettingsViewMenu,
            main: withOnboardingWizard(IntegrationsView)
          }}
          onEnter={trackRoute('integrations')}
        />
      </Route>
      <IndexRedirect to='/settings/channels' />
    </Route>
  )
}



// WEBPACK FOOTER //
// ./client/routes/settings.js